import { render } from "./LayoutVertical.vue?vue&type=template&id=d80ff302"
import script from "./LayoutVertical.vue?vue&type=script&lang=js"
export * from "./LayoutVertical.vue?vue&type=script&lang=js"

import "./LayoutVertical.vue?vue&type=style&index=0&id=d80ff302&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__